import React from 'react';
import Themes from '../Themes';

function PdfHero({ theme, walimatulurus, H2, fontP, H2size, groomName, brideName, weddingDate, textColor }) {

  const Components = Themes[theme];

  const weddingDateSet = new Date(weddingDate);
  const weddingDay = getDayFromDate(weddingDateSet);

  const formattedDate = weddingDateSet.toLocaleDateString('ms-MY', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  });

  // Function to calculate the day from a given date
  function getDayFromDate(date) {
    const days = ['Ahad', 'Isnin', 'Selasa', 'Rabu', 'Khamis', "Jumaat", 'Sabtu'];
    const dayIndex = date.getDay();
    return days[dayIndex];
  }

  // Step 2: Modify the center object to include the animation
  const center = {
    backgroundImage: `url(${Components.fc})`,
    backgroundSize: 'contain',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat'
  };

  const heroPdf = {
    backgroundImage: `url(${Components.bg})`,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
  };

  return (
    <div className={`${Components.themeColor} ${textColor} a6-section w-[105mm] h-[148mm] relative flex flex-col justify-center items-center overflow-hidden`} style={heroPdf}>
      <div className={`${Components.fcPdf}`} style={center} >
        <p className={`text-xs ${fontP} uppercase`}>
          {walimatulurus}
        </p>
        <div className={`${Components.centerText}`}>
          <h2 className={`${Components.H2Pdf} ${H2} capitalize`}>
            {groomName}
          </h2>
          <p className={`text-2xl ${H2} capitalize`} >
            &
          </p>
          <h2 className={`${Components.H2Pdf} ${H2} capitalize`}>
            {brideName}
          </h2>
        </div>
        <p className={`text-xs ${fontP}`}>
          {weddingDay}, {formattedDate}
        </p>
      </div>
      <img
        src={Components.ft}
        className={Components.ftPdf}
      />
      <img
        src={Components.fb}
        className={Components.fbPdf}
      />
    </div>
  );
}

export default PdfHero;
